var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeaWave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33276 3.99841C1.73259 4.3316 2.13242 4.66479 2.99871 4.66479C4.66466 4.66479 4.66466 3.33203 6.33061 3.33203C8.06319 3.33203 7.92992 4.66479 9.6625 4.66479C11.3285 4.66479 11.3285 3.33203 12.9944 3.33203C13.8607 3.33203 14.2605 3.66522 14.6603 3.99841",
    stroke: "#8EC5FF",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33276 7.99646C1.73259 8.32965 2.13242 8.66284 2.99871 8.66284C4.66466 8.66284 4.66466 7.33008 6.33061 7.33008C8.06319 7.33008 7.92992 8.66284 9.6625 8.66284C11.3285 8.66284 11.3285 7.33008 12.9944 7.33008C13.8607 7.33008 14.2605 7.66327 14.6603 7.99646",
    stroke: "#8EC5FF",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33276 11.9945C1.73259 12.3277 2.13242 12.6609 2.99871 12.6609C4.66466 12.6609 4.66466 11.3281 6.33061 11.3281C8.06319 11.3281 7.92992 12.6609 9.6625 12.6609C11.3285 12.6609 11.3285 11.3281 12.9944 11.3281C13.8607 11.3281 14.2605 11.6613 14.6603 11.9945",
    stroke: "#8EC5FF",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_1298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeaWave);
export default __webpack_public_path__ + "static/media/sea_wave.35b4b547cd7836dc0a70330f02ba565c.svg";
export { ForwardRef as ReactComponent };